// Dynamic Google Fonts loader. Only injects the <link> tags AFTER the user
// has granted "functional" consent, and REMOVES them if they revoke.
//
// Also injects a CSS class rule so the app switches from the system font stack
// to the branded fonts (Outfit / Playfair Display / JetBrains Mono).

const LINK_ID = "gf-runtime-link";
const CSS_ID = "gf-runtime-css";

const FONTS_HREF =
  "https://fonts.googleapis.com/css2?" +
  "family=Outfit:wght@300;400;500;600;700&" +
  "family=Playfair+Display:ital,wght@0,400..900;1,400..900&" +
  "family=JetBrains+Mono:wght@400;500;700&display=swap";

const PRECONNECT = [
  ["gf-runtime-pc1", "https://fonts.googleapis.com"],
  ["gf-runtime-pc2", "https://fonts.gstatic.com"],
];

const BRAND_CSS = `
  html.gf-loaded body {
    font-family: "Outfit", ui-sans-serif, system-ui, -apple-system,
      "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  }
  html.gf-loaded .font-serif-display {
    font-family: "Playfair Display", ui-serif, Georgia, Cambria,
      "Times New Roman", Times, serif;
  }
  html.gf-loaded .font-mono-terminal {
    font-family: "JetBrains Mono", ui-monospace, SFMono-Regular, Menlo,
      Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }
`;

export function loadGoogleFonts() {
  if (typeof document === "undefined") return;
  if (document.getElementById(LINK_ID)) return; // already loaded

  // Preconnects (best-practice + faster paint)
  for (const [id, href] of PRECONNECT) {
    if (!document.getElementById(id)) {
      const el = document.createElement("link");
      el.id = id;
      el.rel = "preconnect";
      el.href = href;
      if (href.includes("gstatic")) el.crossOrigin = "";
      document.head.appendChild(el);
    }
  }

  const link = document.createElement("link");
  link.id = LINK_ID;
  link.rel = "stylesheet";
  link.href = FONTS_HREF;
  document.head.appendChild(link);

  if (!document.getElementById(CSS_ID)) {
    const style = document.createElement("style");
    style.id = CSS_ID;
    style.textContent = BRAND_CSS;
    document.head.appendChild(style);
  }

  document.documentElement.classList.add("gf-loaded");
}

export function unloadGoogleFonts() {
  if (typeof document === "undefined") return;
  for (const id of [LINK_ID, CSS_ID, ...PRECONNECT.map((p) => p[0])]) {
    const el = document.getElementById(id);
    if (el) el.remove();
  }
  document.documentElement.classList.remove("gf-loaded");
}
